import React from "react"

import FieldAssignees_PickerValueNotEmpty from "../../../../../generic/assignees/components/picker/value-not-empty"

const debug = false
// const debug = "FieldGoalAssignees_InlineValue"

export default function FieldGoalAssignees_InlineValue(props: any) {

    const goalAssigneesIds  = props.model['assigneeUserIds']
    // const subAssigneesIds   = props.model['subGoalsAssigneeUserIds']

    const goalAssigneesOptions  = props.field._getOptions(goalAssigneesIds)
    // const subAssigneesOptions   = props.field._getOptions(subAssigneesIds)

    debug && console.log(debug, 'render', props)

    // const noAssignees       = _.isEmpty(goalAssigneesOptions)
    // const noSubAssignees    = _.isEmpty(subAssigneesOptions)

    return (
        <div className="flex-row-left-center" onClick={props.onClick}>
            <FieldAssignees_PickerValueNotEmpty noLabel         = {true}
                                                configOptions   = {props.configOptions}
                                                options         = {goalAssigneesOptions} />

            {/*{!noSubAssignees &&
                <FieldAssignees_PickerValueNotEmpty className   = "m-l-10"
                                                    noLabel     = {true}
                                                    options     = {subAssigneesOptions} />}*/}

            {props.children}
        </div>
    )
}
